import { go } from 'connected-react-router';
import { delay, put } from 'redux-saga/effects';

function* refreshUI() {
  yield delay(0);
  yield put(go(0));
}

export default refreshUI;
